export const name = 'viewerManagerDocumentServicesModelApi' as const
